import { useRef, useEffect, useState } from "react";
import { FaGoogle, FaEnvelope } from "react-icons/fa";
import { signInWithGoogle } from "../../services/Firebase";
import { useSelector } from "react-redux";
import LogInWithEmail from "./LogInWithEmail";

export default function Login({ onClose, onOpenSignup }) {
  const modalRef = useRef(null);
  const user = useSelector((state) => state.auth.user);

  const [logInWithEmail, setLogInWithEmail] = useState(false);

  // Close modal if user logs in
  useEffect(() => {
    if (user) onClose && onClose();
  }, [user, onClose]);

  // Close when clicking outside the modal
  useEffect(() => {
    function handleClickOutside(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        onClose && onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const OnLogInWithEmailClicked = () => {
    setLogInWithEmail(true);
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50">
      <div
        ref={modalRef}
        className="bg-[#0f0f0f] text-white w-[90%] max-w-md rounded-xl p-8 relative shadow-2xl animate-fadeIn"
      >
        {/* Close Button */}
        <button
          onClick={() => onClose && onClose()}
          className="absolute top-4 right-4 text-white text-2xl hover:text-gray-300"
        >
          ✕
        </button>

        {/* Logo */}
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold text-red-500">RED VIDEO CHAT</h1>
          <p className="mt-2 text-xl font-semibold">Log In</p>
        </div>

        {/* Google */}
        <button className="w-full flex items-center justify-center gap-3 bg-white text-black py-3 rounded-xl mb-4 font-medium hover:bg-gray-100 transition"
          onClick={signInWithGoogle}>
          <FaGoogle size={20} />
          Sign in with Google
        </button>

        {/* Email */}
        <button className="w-full flex items-center justify-center gap-3 bg-blue-500 py-3 rounded-xl mb-6 font-medium hover:bg-blue-600 transition"
          onClick={OnLogInWithEmailClicked}>
          <FaEnvelope size={20} />
          Login with E-mail
        </button>

        {/* Switch to Signup */}
        <p className="text-center text-sm">
          <button
            onClick={() => {
              onClose && onClose();
              onOpenSignup && onOpenSignup();
            }}
            className="underline text-gray-300 hover:text-white"
          >
            Create an account
          </button>
        </p>

        {/* Terms */}
        <p className="text-center text-xs mt-4 text-gray-400">
          By signing in you agree to our{" "}
          <a
            href="/privacy"
            className="underline text-gray-300 hover:text-white"
          >
            privacy policy
          </a>{" "}
          &{" "}
          <a
            href="/terms"
            className="underline text-gray-300 hover:text-white"
          >
            terms of service
          </a>.
        </p>
      </div>

      {logInWithEmail && <LogInWithEmail onClose={() => {
        setLogInWithEmail(false);
        onClose && onClose();
      }} />}
    </div>
  );
}